/**
 * jf-card-variant-hover.js
 *
 * Product card: forhåndsvis et variant-/relateret produktbillede mens musen er
 * over en swatch (.product-card__swatch-list) eller en variant-thumbnail
 * (.product-card__variant-thumbnails).
 *
 * Kortet viser ALTID featured image som #1 og produktets billede #2 ved
 * kort-hover (styret af CSS). Variantbilleder vises KUN som preview ved hover
 * på en swatch/thumbnail og nulstilles til featured image ved mouse-out.
 *
 * Klik på en swatch håndteres uændret af theme.js (ProductCard), som bytter
 * billedet permanent og opdaterer produktlinket til den valgte variant.
 */
(function () {
  'use strict';

  var TRIGGER_SELECTOR = '.product-card__swatch-list label, .product-card__variant-thumbnail';
  var GROUP_SELECTOR = '.product-card__swatch-list, .product-card__variant-thumbnails';
  var PREVIEW_WIDTH = 1200;

  // Gemmer det oprindelige (featured) billede pr. <img>, så det kan nulstilles.
  var originals = new WeakMap();

  function getPrimaryImage(card) {
    return card ? card.querySelector('.product-card__image--primary') : null;
  }

  function sizedUrl(src, width) {
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (e) {
      return src;
    }
  }

  // Finder preview-billedets URL for et trigger-element (swatch eller thumbnail).
  function previewSrcFor(trigger) {
    // Variant-thumbnail: URL ligger direkte i data-preview-src (sat i Liquid).
    if (trigger.matches('.product-card__variant-thumbnail')) {
      return trigger.getAttribute('data-preview-src') || null;
    }

    // Swatch: variant-mediet ligger på den tilknyttede radio-input (theme.js).
    var radio = trigger.control;
    if (!radio || !radio.hasAttribute('data-variant-media')) return null;

    try {
      var media = JSON.parse(radio.getAttribute('data-variant-media'));
      var src = media && media.preview_image && media.preview_image.src;
      return src ? sizedUrl(src, PREVIEW_WIDTH) : null;
    } catch (e) {
      return null;
    }
  }

  function showPreview(card, src) {
    var image = getPrimaryImage(card);
    if (!image || !src) return;

    if (!originals.has(image)) {
      originals.set(image, {
        src: image.getAttribute('src'),
        srcset: image.getAttribute('srcset')
      });
    }

    image.removeAttribute('srcset');
    image.src = src;
  }

  function restorePreview(card) {
    var image = getPrimaryImage(card);
    if (!image || !originals.has(image)) return;

    var original = originals.get(image);
    originals.delete(image);

    if (original.srcset) {
      image.setAttribute('srcset', original.srcset);
    } else {
      image.removeAttribute('srcset');
    }
    if (original.src) image.src = original.src;
  }

  document.addEventListener('pointerover', function (event) {
    if (!(event.target instanceof Element)) return;

    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    var card = trigger.closest('product-card');
    if (!card) return;

    showPreview(card, previewSrcFor(trigger));
  });

  document.addEventListener('pointerout', function (event) {
    if (!(event.target instanceof Element)) return;

    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    var card = trigger.closest('product-card');
    if (!card) return;

    // Bevar preview hvis musen stadig er inden for samme gruppe — fx når man
    // bevæger sig fra én swatch til en anden i samme liste.
    var group = trigger.closest(GROUP_SELECTOR);
    if (group && event.relatedTarget && group.contains(event.relatedTarget)) return;

    restorePreview(card);
  });
})();
